<template>
  <div>
    <div class="color-dark-purple">
      <h3>DETALHE DO CANDIDATO(A) <b v-if="this.candidate.is_deleted" style='color:red'>Removido</b></h3>
    </div>
    <div class="col-lg-12 border-dark-purple">
      <div class="row">
        <div class="col-lg-12 col-xs-12">
          <div
            style="margin-right: 10px !important; float: right"
            class="menu_column nav nav-tabs mt-2 mr-2"
          >
            <li
              style="background-color: #f4f4f4 !important"
              class="nav-item dropdown"
            >
              <div
                class="nav-link"
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
                style="background-color: #fcfcfc"
              >
                <font-awesome-icon icon="ellipsis-h" />
              </div>
              <div class="dropdown-menu drop-down-tb">
                <div class="dropdown-item pointer">
                  <span class="mt-0 mb-0" @click="openForm()"> EDITAR </span>
                  <i class="ml-4 fa fa-pencil-alt scale_1" />
                </div>
                <div class="dropdown-item pointer">
                  <span class="mt-0 mb-0" @click="removeCandidate()"> REMOVER CANDIDATO </span>
                  <i class="ml-4 fa fa-trash-alt scale_1" />
                </div>
              </div>
            </li>
          </div>
        </div>
        <div class="col-lg-2">
          <div class="w-100 h-100 d-table">
            <img
              class="thumb-box mt-3 mb-2 d-table-cell align-middle"
              :src="apply ? apply.image : '/images/avatar.png'"
            />
          </div>
        </div>
        <div class="col-lg-9">
          <div class="col-lg-12 col-xs-12">
            <div class="row mt-1 mb-2">
              <div class="col-lg-2 col-xs-12">
                <span>NOME</span>
              </div>
              <div class="col-lg-10 col-xs-12">
                <span>
                  {{ showField(candidate_data.name) }}
                </span>
              </div>
            </div>
            <div class="row mt-1 mb-2">
              <div class="col-lg-2 col-xs-12">
                <span>EMAIL</span>
              </div>
              <div class="col-lg-10 col-xs-12">
                <span>
                  {{ showField(candidate_data.email) }}
                </span>
              </div>
            </div>
            <div class="row mt-1 mb-2">
              <div class="col-lg-2 col-xs-12">
                <span>TELEFONE</span>
              </div>
              <div class="col-lg-10 col-xs-12">
                <span>
                  {{ showField(candidate_data.mobile_phone) }}
                </span>
              </div>
            </div>
            <div class="row mt-1 mb-2">
              <div class="col-lg-2 col-xs-12">
                <span>SALARIO</span>
              </div>
              <div class="col-lg-10 col-xs-12">
                <span>
                  {{ showField(candidate_data.remuneration, true) }}
                </span>
              </div>
            </div>
            <div class="row mt-1 mb-2">
              <div class="col-lg-2 col-xs-12">
                <span>PORTFÓLIO</span>
              </div>
              <div class="col-lg-10 col-xs-12">
                <span>
                  {{ showField(candidate_data.personal_portfolio) }}
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-2 col-xs-12">
                <span>SITE PESSOAL</span>
              </div>
              <div class="col-lg-10 col-xs-12">
                <span>
                  {{ showField(candidate_data.personal_portfolio) }}
                </span>
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-lg-2 col-xs-12">
                <span>LINKEDIN</span>
              </div>
              <div class="col-lg-10 col-xs-12">
                <span>
                  {{ showField(candidate_data.linkedin_url) }}
                </span>
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-lg-2 col-xs-12">
                <span>CIDADE NATAL</span>
              </div>
              <div class="col-lg-10 col-xs-12">
                <span>
                  {{ candidate_data.hometown_attributes ? 
                    `${candidate_data.hometown_attributes.name}/${candidate_data.hometown_state_attributes.name}`:
                    `Não Informado`
                  }}
                </span>
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-lg-2 col-xs-12">
                <span>ETNIA</span>
              </div>
              <div class="col-lg-10 col-xs-12">
                <span>
                  {{ getEthnicity(candidate_data.ethnicity) || "Não Informado" }}
                </span>
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-lg-2 col-xs-12">
                <span>ORIENTAÇÃO SEXUAL</span>
              </div>
              <div class="col-lg-10 col-xs-12">
                <span>
                  {{ getSexualOrientation(candidate_data.sexual_orientation) || "Não Informado" }}                
                </span>
              </div>
            </div>
            <div class="row mt-1 mb-3">
              <div class="col-lg-2 col-xs-12">
                <span>PCD</span>
              </div>
              <div class="col-lg-10 col-xs-12">
                <span>
                  {{ candidate_data.is_pcd ? candidate_data.pcd_description : "Não" }}
                </span>
              </div>
            </div>
            <div class="row mt-1 mb-1">
              <div class="col-lg-2 hide col-xs-12">
                <span>COMPETENCIAS</span>
              </div>
              <div class="col-lg-10 col-xs-12">
                <div class="skill_uni" v-for="skill in skills" :key="skill.id">
                  {{ skill.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
          

<script>
import { format } from "date-fns";
import { state } from "store/business.js";
import axios from "axios";
import CandidateForm from "./Form.vue";
export default {
  props: ["candidate", "apply", "applies", "skills"],
  data: () => ({
    candidate_data: {},
    state: state,
    ethnicities: [
      { id: 0, name: "Indígena" },
      { id: 1, name: "Branco" },
      { id: 2, name: "Negro" },
      { id: 3, name: "Pardo" },
      { id: 4, name: "Oriental" },
      { id: 5, name: "Prefiro não informar" },
      { id: 6, name: "Indefinido" },
    ],
    sexual_orientations: [
      { id: 0, name: "Heterossexual" },
      { id: 1, name: "Bissexual" },
      { id: 2, name: "Pansexual" },
      { id: 4, name: "Homossexual" },
      { id: 3, name: "Prefiro não informar" }
    ],
  }),
  mounted() {
    eventBus.$on("updateInfo", (_) => {
      this.getInfo();
    });

    this.candidate_data = this.candidate;
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "BRL",
      })
        .format(value)
        .replace("R$", "")
        .trim();
    },
    openForm() {
      this.$modal.show(
        CandidateForm,
        {
          candidate_edit: this.candidate_data,
        },
        {
          width: "70%",
          height: "auto",
          scrollable: true,
        }
      );
    },
    showField(field, monetary = false) {
      if (field == null || "" || "" || field.length == 0 || field == 0) {
        return "Não Informado";
      } else {
        return monetary ? this.formatCurrency(field) : field;
      }
    },
    removeCandidate(){
      let conf = confirm("Tem certeza que deseja REMOVER esse CANDIDATO(A)?");
      if (!conf) return;
      axios
        .delete(
          `/recruiters/talent_banks/${this.candidate.id}/candidate/delete`
        )
        .then((response) => {
          if(response.status == 200){
            this.$toast.success("Removido com sucesso");
            
            setTimeout(() => {
              window.location = "/recruiters/talent_banks/candidates";
            }, 1000)
          }
        });
    },
    getInfo() {
      axios
        .get(
          `/recruiters/talent_banks/${this.candidate.talent_banks_id}/candidate/info`
        )
        .then((response) => {
          this.candidate_data = response.data.candidate;
        });
    },
    getEthnicity(ethnicity_id) {
      if (ethnicity_id || ethnicity_id == 0)
        return (
          this.ethnicities.find(ethnicity => ethnicity.id === ethnicity_id)
        ).name;
      return 'Não Informado'
    },
    getSexualOrientation(sexual_orientation_id) {
      if (sexual_orientation_id || sexual_orientation_id == 0)
        return (
          this.sexual_orientations.find(
            sexual_orientation => sexual_orientation.id === sexual_orientation_id
          )
        ).name;
      return 'Não Informado'
    },
    setExtraOptions() {
      if (this.state.extra_options) {

        this.state.extra_options?.ethnicity?.length > 0 ?  
          this.ethnicities = this.state.extra_options?.ethnicity?.map((ethnicity, index) => {
            return { name: ethnicity, id: index }
          }) 
        : this.ethnicities;

        this.state.extra_options?.sexual_orientation?.length > 0 ?  
          this.sexual_orientations = this.state.extra_options?.sexual_orientation?.map((sexual_orientation, index) => {
            return { name: sexual_orientation, id: index }
          })
        : this.sexual_orientations;
      }
    }
  },
  watch: {
    "state.extra_options"() {
      this.setExtraOptions();
    }
  }
};
</script>
